import { z } from 'zod';

import { isTenantSlugAvailable, normalizeTenantSlug } from '../tenant';
import type { FeatureKeyEnumType } from './features.dto';

export const StatusTenant = z.enum(['ATIVO', 'SUSPENSO']);

/** O slug chega livre de capitalização/espaços e atravessa a API já normalizado; o middleware de host usa a mesma regra. */
export const TenantSlugInput = z
  .string()
  .transform(normalizeTenantSlug)
  .refine(isTenantSlugAvailable, 'Slug inválido ou reservado.');

export type TenantOutput = {
  id: string;
  slug: string;
  nome: string;
  status: StatusTenantType;
  criadoEm: string;
  atualizadoEm: string;
  /** Só o Sys Admin altera. */
  features: FeatureKeyEnumType[];
};

export const TenantCreateInput = z.object({
  nome: z.string().trim().min(1),
  slug: TenantSlugInput,
  administrador: z.object({
    nome: z.string().trim().min(1),
    email: z.email(),
  }),
});

export const TenantUpdateInput = z
  .object({
    nome: z.string().trim().min(1).optional(),
    status: StatusTenant.optional(),
  })
  .refine((input) => input.nome !== undefined || input.status !== undefined, {
    message: 'Informe ao menos um campo para atualizar.',
  });

export type StatusTenantType = z.infer<typeof StatusTenant>;
export type TenantOutputType = TenantOutput;
export type TenantCreateInputType = z.infer<typeof TenantCreateInput>;
export type TenantUpdateInputType = z.infer<typeof TenantUpdateInput>;
